// src/utils/energyFormat.js
/**
 * Energy summary formatting + derived environmental-impact calculations.
 * Formulas ported from cbms_app's UsageService (diesel-generator backup offset estimates).
 */

export function formatPower(powerWh) {
  const kWh = powerWh / 1000;
  if (kWh >= 1000) {
    return `${(kWh / 1000).toFixed(2)} MWh`;
  } else if (kWh >= 1) {
    return `${kWh.toFixed(2)} kWh`;
  }
  return `${(kWh * 1000).toFixed(0)} Wh`;
}

export function formatPowerForTable(powerWh) {
  return `${(powerWh / 1000).toFixed(2)} kWh`;
}

export function formatTime(hours) {
  const h = typeof hours === 'string' ? parseFloat(hours) : hours;
  if (h >= 1) {
    return `${h.toFixed(2)} hrs`;
  }
  return `${Math.round(h * 60)} min`;
}

export function calculateDieselSavedByTime(backupHours) {
  return backupHours * 1.92;
}

export function calculateCO2Saved(dieselLiters) {
  return dieselLiters * 2.68;
}

export function formatDiesel(liters) {
  if (liters >= 1000) {
    return `${(liters / 1000).toFixed(2)} kL`;
  } else if (liters >= 1) {
    return `${liters.toFixed(1)} L`;
  }
  return `${(liters * 1000).toFixed(0)} mL`;
}

export function formatCO2(kg) {
  if (kg >= 1000) {
    return `${(kg / 1000).toFixed(2)} tonnes`;
  }
  return `${kg.toFixed(1)} kg`;
}

export function countUniqueSessions(sessions) {
  const uniqueStartTimes = new Set((sessions || []).map(s => s.start_time));
  return uniqueStartTimes.size;
}
